import { useContext } from "react";
import Loading from "../../components/basics/Loading";
import HeaderModule from "../../components/header/HeaderModule";
import ContentForm from "./children/ContentForm";
import {
  TemplateEmailsContext,
  TemplateEmailsContextProvider,
} from "./contexts/TemplateEmailsContext";

const View = ({ location }) => {
  const { mainLoading } = useContext(TemplateEmailsContext);
  return (
    <>
      <Loading open={mainLoading} />
      <HeaderModule title="FORMULÁRIO DE CONTEÚDO DE EMAILS" />
      <ContentForm location={location} />
    </>
  );
};

const EmailsContentForm = ({ ...props }) => (
  <TemplateEmailsContextProvider>
    <View {...props} />
  </TemplateEmailsContextProvider>
);

export default EmailsContentForm;
